"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _help = _interopRequireDefault(require("../../components/help"));

var _label = _interopRequireWildcard(require("./label.style"));

var _validationIcon = _interopRequireDefault(require("../validations/validation-icon.component"));

var _iconWrapper = _interopRequireDefault(require("./icon-wrapper.style"));

var _inputBehaviour = require("../input-behaviour");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const shouldDisplayValidationIcon = ({
  error,
  warning,
  info,
  disabled
}) => {
  const validation = error || warning || info;
  return disabled ? false : typeof validation === "string";
};

const tooltipPosition = ({
  error,
  warning,
  info,
  inline
}) => {
  return (error || warning || info) && inline === true ? "top" : "right";
};

const Label = ({
  disabled,
  inline,
  align = "right",
  width,
  childOfForm,
  optional,
  labelId,
  helpId,
  children,
  error,
  warning,
  info,
  help,
  helpIcon,
  helpTag,
  helpTabIndex,
  useValidationIcon = true,
  htmlFor,
  pr,
  pl,
  isRequired
}) => {
  const [isFocused, setFocus] = (0, _react.useState)(false);
  const {
    onMouseEnter,
    onMouseLeave
  } = (0, _react.useContext)(_inputBehaviour.InputContext);
  const {
    onMouseEnter: onGroupMouseEnter,
    onMouseLeave: onGroupMouseLeave
  } = (0, _react.useContext)(_inputBehaviour.InputGroupContext);

  const handleMouseEnter = ev => {
    if (onMouseEnter) onMouseEnter(ev);
    if (onGroupMouseEnter) onGroupMouseEnter(ev);
  };

  const handleMouseLeave = ev => {
    if (onMouseLeave) onMouseLeave(ev);
    if (onGroupMouseLeave) onGroupMouseLeave(ev);
  };

  const icon = () => {
    const wrapperProps = {
      onFocus: () => setFocus(true),
      onBlur: () => setFocus(false)
    };

    if (useValidationIcon && shouldDisplayValidationIcon({
      error,
      warning,
      info,
      disabled
    })) {
      const tooltipPositionValue = tooltipPosition({
        error,
        warning,
        info,
        inline
      });
      return /*#__PURE__*/_react.default.createElement(_iconWrapper.default, null, /*#__PURE__*/_react.default.createElement(_validationIcon.default, {
        iconId: helpId,
        error: error,
        warning: warning,
        info: info,
        tooltipPosition: tooltipPositionValue,
        tooltipFlipOverrides: ["top", "bottom"]
      }));
    }

    return help && /*#__PURE__*/_react.default.createElement(_iconWrapper.default, wrapperProps, /*#__PURE__*/_react.default.createElement(_help.default, {
      helpId: helpId,
      as: helpTag,
      tabIndex: helpTabIndex,
      type: helpIcon,
      isFocused: isFocused
    }, help));
  };

  return /*#__PURE__*/_react.default.createElement(_label.StyledLabelContainer, {
    align: align,
    inline: inline,
    width: width,
    optional: optional,
    childOfForm: childOfForm,
    pr: pr,
    pl: pl
  }, /*#__PURE__*/_react.default.createElement(_label.default, {
    "data-element": "label",
    disabled: disabled,
    id: labelId,
    htmlFor: htmlFor,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    isRequired: isRequired
  }, children), icon());
};

Label.propTypes = {
  /** Label width */
  width: _propTypes.default.number,

  /** Label alignment */
  align: _propTypes.default.oneOf(["left", "right"]),

  /** Flag to indicate that component is used in a Form */
  childOfForm: _propTypes.default.bool,

  /** When true, label is placed in line an input */
  inline: _propTypes.default.bool,

  /** If true, the component will be disabled */
  disabled: _propTypes.default.bool,

  /** Flag to configure component as optional in Form */
  optional: _propTypes.default.bool,

  /** The unique id of the label element */
  labelId: _propTypes.default.string,

  /** The unique id of the Help component */
  helpId: _propTypes.default.string,

  /** Children elements */
  children: _propTypes.default.node,

  /** Status of error validations */
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /** Status of warnings */
  warning: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /** Status of info */
  info: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /** A message that the Help component will display */
  help: _propTypes.default.node,

  /** Icon type */
  helpIcon: _propTypes.default.string,

  /** Overrides the default 'as' attribute of the Help component */
  helpTag: _propTypes.default.string,

  /** Overrides the default tabindex of the Help component */
  helpTabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** Whether to show the validation icon */
  useValidationIcon: _propTypes.default.bool,

  /** A string that represents the ID of another form element */
  htmlFor: _propTypes.default.string,

  /** Padding right, integer multiplied by base spacing constant (8) */
  pr: _propTypes.default.oneOf([1, 2]),

  /** Padding left, integer multiplied by base spacing constant (8) */
  pl: _propTypes.default.oneOf([1, 2]),

  /** Flag to configure component as mandatory */
  isRequired: _propTypes.default.bool
};

var _default = /*#__PURE__*/_react.default.memo(Label);

exports.default = _default;